require('picturefill');
import $ from 'jquery';
window.$ = $;
import Parsley from 'parsleyjs';
import FormValidationView from './views/FormValidationView';

import { BaseController } from './core/BaseController';
import ToggleView from './views/ToggleView';
import ModalView from './views/ModalView';
import NavigationView from './views/NavigationView';
import SiteMessageView from "./views/SiteMessageView";
import FormStepperView from "./views/FormStepperView";
import CarouselView from './views/CarouselView';
import CustomCheckBoxView from './views/CustomCheckBoxView';
import ProductCarouselView from './views/ProductCarouselView';
import ProductDetailView from './views/ProductDetailView';
import ProductSeriesView from './views/ProductSeriesView';
import OrderHistoryView from './views/OrderHistoryView';
import CheckoutInfoView from './views/CheckoutInfoView';
import CheckoutPlaceOrderView from './views/CheckoutPlaceOrderView';
import CartController from './controllers/CartController';
import CheckboxDependenciesView from './views/CheckboxDependenciesView';
import ChooseAddressView from './views/ChooseAddressView';
import { eventEmitter } from "./global/eventEmitter";
import ParsleyHelper from "./util/ParsleyHelper";
import Sortable from "./util/Sortable";
import CheckoutTracking from './views/CheckoutTracking';
import ReorderView from './views/ReorderView';

/**
 * Application setup
 *
 * @class App
 */

const SELECTORS = {
    BODY: 'body',
    FORM_VALIDATION: '.js-form-validation',
    FORM_STEPPER: '.js-stepper',
    TOGGLE: '.js-toggleView',
    NAVIGATION_VIEW: '.js-navigationView',
    TEST_MODAL: '.js-testModal',
    CART_CONTROLLER: '.js-cartController',
    PRODUCT_CAROUSEL: '[data-carousel]',
    PRODUCTCAROUSEL_VIEW: '.js-productCarousel',
    CUSTOM_CHECKBOX: '.js-customCheckbox',
    PRODUCTDETAIL_VIEW: '.js-productDetailView',
    PRODUCTSERIES_VIEW: '.js-productSeries',
    CHECKBOX_DEPENDENCIES_VIEW: '.js-checkBoxDependencies',
    CHOOSE_ADDRESS_VIEW: '.js-chooseAddressView',
    ORDER_HISTORY: '.js-order-history',
    PLACE_ORDER: '.js-checkout-review-order',
    REORDER_VIEW: '.js-reorderView',
    CHECKOUT_INFO_VIEW: '.js-checkout-info',
    CHECKOUT_STEPS_VIEW: '.js-checkoutSteps'
};

const instanceMap = new Map();
export default class App {

    constructor() {
        // super();

        this.init();
    }

    init() {
        this.createChildren()
            .enable();

        return this;
    }

    /**
     * All constructor functions
     * are gathered under createChildren.
     *
     * @method createChildren
     * @public
     * @chainable
     * @returns {Object}
     */
    createChildren() {
        // global
        this.eventEmitter = eventEmitter;
        ParsleyHelper.addValidators();

        // Controllers
        this.getInstance(CartController, $(SELECTORS.CART_CONTROLLER));

        // Views
        this.getInstance(FormStepperView, $(SELECTORS.FORM_STEPPER));
        this.getInstance(ToggleView, $(SELECTORS.TOGGLE));
        this.getInstance(ModalView, $(SELECTORS.TEST_MODAL));
        this.getInstance(NavigationView, $(SELECTORS.NAVIGATION_VIEW));
        this.getInstance(CarouselView, $(SELECTORS.PRODUCT_CAROUSEL));
        this.getInstance(CheckoutPlaceOrderView, $(SELECTORS.PLACE_ORDER));
        this.getInstance(CheckoutTracking, $(SELECTORS.CHECKOUT_STEPS_VIEW));
        this.getInstance(CustomCheckBoxView, $(SELECTORS.CUSTOM_CHECKBOX));
        this.getInstance(ProductCarouselView, $(SELECTORS.PRODUCTCAROUSEL_VIEW));
        this.getInstance(ProductDetailView, $(SELECTORS.PRODUCTDETAIL_VIEW));
        this.getInstance(ProductSeriesView, $(SELECTORS.PRODUCTSERIES_VIEW));
        this.getInstance(FormValidationView, $(SELECTORS.FORM_VALIDATION));
        this.getInstance(CheckboxDependenciesView, $(SELECTORS.CHECKBOX_DEPENDENCIES_VIEW));
        this.getInstance(ChooseAddressView, $(SELECTORS.CHOOSE_ADDRESS_VIEW));
        this.getInstance(OrderHistoryView, $(SELECTORS.ORDER_HISTORY));
        this.getInstance(CheckoutInfoView, $(SELECTORS.CHECKOUT_INFO_VIEW));
        this.getInstance(ReorderView, $(SELECTORS.REORDER_VIEW));
        new Sortable();

        return this;
    }

    getInstance(ClassRef, container) {
        if (!instanceMap[ClassRef]) { // fixes previous line            
            container.each((i, val) => {
                instanceMap.set(ClassRef, new ClassRef($(val))); // fixes previous line
            });

            return this[ClassRef];
        }
        return this[ClassRef];
    }

    enable() {
        this.eventEmitter.on('modal-open', () => {
            this.modalOpen();
        });
    }

    /**
    * Method modalOpen reattaches form validation to new forms created inside a modal
    *
    * @method modalOpen
    * @chainable
    * @public
    */
    modalOpen() {
        const $newForm = $('.js-modal .js-form-validation');
        new FormValidationView($newForm);
    }
}